import React, { useState, useEffect } from "react";
import "../../../styles/desktop/chamados.css";
import Acao from "./acao/acao";
import updateChamadoSolution from "../../../API/server/updateSolucaoChamado";
import updateRegistrosEChamados from "../../../API/node-red/updateRegistrosEChamados";

export default function Chamados({ evento, onClose, getData, chamados = [] }) {
    const [showAcao, setShowAcao] = useState(false);
    const [chamadoDetalhes, setChamadoDetalhes] = useState(null);
    const [loading, setLoading] = useState(true);
    const [solucao, setSolucao] = useState("");
    const [registrosAssociados, setRegistrosAssociados] = useState([]);

    useEffect(() => {
        const buscarChamado = () => {
            try {
                // Encontra o chamado correspondente ao evento atual
                const chamado = chamados.find(c => {
                    const registroInicial = c.id_registro_inicial?.toString();
                    const registroFinal = c.id_registro_final?.toString();
                    const eventoId = evento.id.toString();
                    
                    return registroInicial === eventoId || registroFinal === eventoId;
                });
                
                if (chamado) {
                    // Buscar todos os registros relacionados a este chamado
                    const registros = [];
                    
                    // Buscar o registro inicial
                    if (chamado.id_registro_inicial) {
                        // Tenta encontrar o registro inicial entre os eventos
                        const eventoInicial = evento.id.toString() === chamado.id_registro_inicial.toString() ? 
                            evento : null;
                            
                        if (eventoInicial) {
                            registros.push(eventoInicial);
                        } else {
                            // Se não for o evento atual, buscar nos eventos disponíveis
                            // (Na prática, seria necessário buscar este evento se não estiver disponível)
                            console.log("Buscando registro inicial:", chamado.id_registro_inicial);
                        }
                    }
                    
                    // Buscar o registro final se for diferente do inicial
                    if (chamado.id_registro_final && 
                        chamado.id_registro_final !== chamado.id_registro_inicial) {
                        
                        const eventoFinal = evento.id.toString() === chamado.id_registro_final.toString() ? 
                            evento : null;
                            
                        if (eventoFinal) {
                            // Se já não tiver sido adicionado como inicial
                            if (registros.length === 0 || registros[0].id !== eventoFinal.id) {
                                registros.push(eventoFinal);
                            }
                        } else {
                            // Se não for o evento atual, buscar nos eventos disponíveis
                            console.log("Buscando registro final:", chamado.id_registro_final);
                        }
                    }
                    
                    // Se não encontrou nenhum registro, pelo menos adicione o evento atual
                    if (registros.length === 0) {
                        registros.push(evento);
                    }
                    
                    // Em um caso real, você precisaria buscar os outros registros do servidor
                    // Neste exemplo, vamos criar registros fictícios baseados nos IDs
                    
                    // Adicionar registro inicial se não estiver presente e for diferente do evento
                    if (chamado.id_registro_inicial && 
                        !registros.some(r => r.id.toString() === chamado.id_registro_inicial.toString())) {
                        
                        // Aqui você deveria buscar o registro inicial do servidor
                        // Por enquanto, criamos um objeto de exemplo
                        const registroInicial = {
                            id: chamado.id_registro_inicial,
                            tipo: "DVR",
                            nome: "DVR Intelbras",
                            ip: "192.168.1.122",
                            descricao: "O dispositivo perdeu a conexão com a rede.",
                            data: evento.data, // Usando a mesma data do evento atual
                            hora: "15:15:28" // Hora fictícia
                        };
                        
                        registros.unshift(registroInicial);
                    }
                    
                    // Adicionar registro final se não estiver presente e for diferente do evento
                    if (chamado.id_registro_final && 
                        !registros.some(r => r.id.toString() === chamado.id_registro_final.toString())) {
                        
                        // Aqui você deveria buscar o registro final do servidor
                        // Por enquanto, criamos um objeto de exemplo
                        const registroFinal = {
                            id: chamado.id_registro_final,
                            tipo: "DVR",
                            nome: "DVR Intelbras",
                            ip: "192.168.1.122",
                            descricao: "O dispositivo retornou a rede.",
                            data: evento.data, // Usando a mesma data do evento atual
                            hora: "15:16:12" // Hora fictícia
                        };
                        
                        registros.push(registroFinal);
                    }
                    
                    setRegistrosAssociados(registros);
                    setChamadoDetalhes({
                        chamado,
                        registros
                    });
                } else {
                    // Se não encontrar chamado, cria um objeto padrão apenas com o evento atual
                    setRegistrosAssociados([evento]);
                    setChamadoDetalhes({
                        chamado: null,
                        registros: [evento]
                    });
                }
            } catch (error) {
                console.error("Erro ao buscar detalhes do chamado:", error);
                setRegistrosAssociados([evento]);
                setChamadoDetalhes({
                    chamado: null,
                    registros: [evento]
                });
            } finally {
                setLoading(false);
            }
        };

        buscarChamado();
    }, [evento, chamados]);

    const handleRealizarAcao = () => {
        setShowAcao(true);
    };

    const setStatusMessage = () => {
        if (!chamadoDetalhes || !chamadoDetalhes.chamado) {
            return "Ocorrência";
        }
        
        let statusLabel;

        if (chamadoDetalhes.chamado.solucao) {
            statusLabel = "Concluído";
        } else if (chamadoDetalhes.chamado.status === "aberto") {
            statusLabel = "Pendente";
        } else if (chamadoDetalhes.chamado.status === "em andamento") {
            statusLabel = "Solicitação enviada para o responsável";
        } else {
            statusLabel = "Concluído pendente";
        }
        return statusLabel;
    };

    const handleSalvarSolucao = async () => {
        if (solucao) {
            // Ativar indicador de carregamento no componente pai
            getData(true); // Passando true para indicar que está carregando
            
            try {
                // Atualiza o status e salva a solução no backend
                const response = await updateChamadoSolution(chamadoDetalhes.chamado.id, solucao);
    
                if (response?.chamado) {
                    
                    // 2. Atualizar registros e chamados no Node-RED
                    await updateRegistrosEChamados();
                    
                    // 3. Atualizar estado local
                    const atualizado = {
                        ...chamadoDetalhes,
                        chamado: {
                            ...response.chamado,
                            status: "Concluído",
                            solucao: response.chamado.solucao,
                        },
                    };
                    setChamadoDetalhes(atualizado);
                    
                    // 4. Atualizar os dados no componente pai
                    await getData(); // Esperar atualização completa
                    
                    alert("Solução salva com sucesso!");
                } else {
                    alert("Erro ao salvar a solução: " + response.error);
                    getData(false); // Desativar carregamento em caso de erro
                }
            } catch (error) {
                console.error("Erro ao salvar solução:", error);
                alert("Erro ao salvar a solução.");
                getData(false); // Desativar carregamento em caso de erro
            }
        } else {
            alert("Por favor, selecione uma solução antes de salvar.");
        }
    };

    const renderBtnOptions = () => {
        if (!chamadoDetalhes || !chamadoDetalhes.chamado) {
            return (
                <div className="buttonOpçoesChamados">
                    <button className="btnChamados" onClick={handleRealizarAcao}>
                        Realizar ação
                    </button>
                    <button id="btnAcao-voltar" className="btnChamados" onClick={onClose}>
                        Deixar para depois
                    </button>
                </div>
            );
        }
        
        if (chamadoDetalhes.chamado.solucao) {
            return (
                <button id="btnAcao-acao" className="btnChamados" onClick={onClose}>
                    Voltar
                </button>
            );
        } else if (chamadoDetalhes.chamado.status === "concluído") {
            return (
                <div className="buttonOpçoesChamados">
                    <button className="btnChamados" onClick={handleSalvarSolucao}>
                        Finalizar Chamado
                    </button>
                    <button id="btnAcao-voltar" className="btnChamados" onClick={onClose}>
                        Deixar para depois
                    </button>
                </div>
            );
        } else if (chamadoDetalhes.chamado.status === "em andamento") {
            return (
                <div className="buttonOpçoesChamados">
                    <button id="btnAcao-acao" className="btnChamados" onClick={onClose}>
                        Voltar
                    </button>
                </div>
            );
        } else {
            return (
                <div className="buttonOpçoesChamados">
                    <button className="btnChamados" onClick={handleRealizarAcao}>
                        Realizar ação
                    </button>
                    <button id="btnAcao-voltar" className="btnChamados" onClick={onClose}>
                        Deixar para depois
                    </button>
                </div>
            );
        }
    };

    return (
        <div className="contentChamado">
            {loading ? (
                <p>Carregando detalhes do chamado...</p>
            ) : !showAcao ? (
                <>
                    <div className="headerChamado">
                        <div className="detalhesHeader">
                            <h3>Detalhes do Chamado</h3>
                        </div>
                        {chamadoDetalhes && (
                            <div className="detalhesEventosChamados">
                                {chamadoDetalhes.registros.map((registro, index) => (
                                    <div key={index} className="registroItem">
                                        <p><strong>Registro ID:</strong> {registro.id}</p>
                                        <p><strong>Dispositivo:</strong> {registro.tipo} - {registro.nome}</p>
                                        <p><strong>IP Controlador:</strong> {registro.ip}</p>
                                        <p><strong>Descrição:</strong> {registro.descricao}</p>
                                        <p><strong>Data:</strong> {registro.data}</p>
                                        <p><strong>Hora:</strong> {registro.hora}</p>
                                        {index < chamadoDetalhes.registros.length - 1 && (
                                            <hr />
                                        )}
                                    </div>
                                ))}
                                <p>
                                    <strong>Status:</strong>{" "}
                                    {setStatusMessage()}
                                </p>
                                {chamadoDetalhes?.chamado?.solucao && (
                                    <p>
                                        <strong>Solução:</strong> {chamadoDetalhes.chamado.solucao}
                                    </p>
                                )}
                                {chamadoDetalhes?.chamado?.nome_user_abertura && (
                                    <p>
                                        <strong>Usuário que reportou o chamado:</strong> {chamadoDetalhes.chamado.nome_user_abertura || "chatbot"}
                                    </p>
                                )}
                                {chamadoDetalhes?.chamado?.nome_user_final && (
                                    <p>
                                        <strong>Usuário que finalizou o chamado:</strong> {chamadoDetalhes.chamado.nome_user_final}
                                    </p>
                                )}
                                
                                {chamadoDetalhes?.chamado &&
                                    !chamadoDetalhes.chamado.solucao &&
                                    chamadoDetalhes.chamado.status === "concluído" && (
                                        <div className="solucaoSection">
                                            <label htmlFor="solucaoSelect">Como foi solucionado?</label>
                                            <select
                                                id="solucaoSelect"
                                                value={solucao}
                                                onChange={(e) => setSolucao(e.target.value)}
                                            >
                                                <option value="" disabled>Selecione...</option>
                                                <option value="Atendimento do Chamado">Atendimento do Chamado</option>
                                                <option value="Verificação Interna">Verificação Interna</option>
                                                <option value="Voltou Sozinho">Voltou Sozinho</option>
                                            </select>
                                        </div>
                                    )}
                            </div>
                        )}
                    </div>
                    {renderBtnOptions()}
                </>
            ) : (
                <Acao 
                    onClose={() => setShowAcao(false)} 
                    updateRegistros={getData}
                    fecharPai={onClose}
                    chamadoDetalhes={chamadoDetalhes} 
                />
            )}
        </div>
    );
}